import React from 'react'
import { useState } from 'react'

export default function Slideshow({ slides }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const slideStyle = {
        width: '100%',
        height: '100%',
        backgroundImage: `url(${slides[currentIndex].url})`,
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        borderRadius: '1rem',
        transition: 'background 0.5s ease-in-out',
    };
    const sliderStyle = {
        height: '100%',
        position: 'relative',
    };
    const leftArrow = {
        position: 'absolute',
        top: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding:'1%',
        transform: 'translate(0,-50%)',
        left: '1rem',
        zIndex: 1,
        cursor: 'pointer',
        fontSize: '1.5rem',
        color: '#000',
        backgroundColor: '#D3D3D359',
        borderRadius: '50%',
        textAlign: 'center',
    }
    const rightArrow = {
        position: 'absolute',
        top: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding:'1%',
        transform: 'translate(0,-50%)',
        right: '1rem',
        zIndex: 1,
        cursor: 'pointer',
        fontSize: '1.5rem',
        color: '#000',
        backgroundColor: '#D3D3D359',
        borderRadius: '50%',
        textAlign: 'center',
    }

    const dotsContainerStyle = {
        display: 'flex',
        justifyContent:'center',
    }

    function prevSlides() {
        const isFirstSlide = currentIndex === 0;
        const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
        setCurrentIndex(newIndex);
    };
    function nextSlides () {
        const isLastSlide = currentIndex === slides.length - 1
        const newIndex = isLastSlide ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex)
    };
    const goToSlide = (slideIndex) => {
        setCurrentIndex(slideIndex)
    };
    return(
        <div style={sliderStyle}>
            <i onClick={prevSlides} className="bi bi-arrow-left" style={leftArrow}></i>
            <i onClick={nextSlides} className="bi bi-arrow-right" style={rightArrow}></i>
            <div style={slideStyle}></div> 
            <div style={dotsContainerStyle}>
                {slides.map((slide, slideIndex) => (<div key={slideIndex}><i onClick={()=>goToSlide(slideIndex)} style={{fontSize: '0.5rem',cursor:'pointer',margin:'0 0.3rem'}} className="bi bi-circle-fill"></i></div>
                ))}
            </div>
        </div>
    )
}